<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  mounted() {},
  methods: {},
  data() {
    return {};
  },
};
</script>

<style>
</style>
